import { createFileRoute } from '@tanstack/react-router';
import { BeneficiariesPage } from '@/features/beneficiaries';

export const Route = createFileRoute('/_authenticated/beneficiaries')({
  component: BeneficiariesPage,
});
